import React from 'react'
import ShopSignUpForm from '../../../components/auth/ShopSignUpForm'
import CustomerSignUpForm from '../../../components/auth/CustomerSignUpForm'
import USER_TYPE from '../../../constants/userType'

const StepAccountRegistration = (props) => {
  const { userType } = props

  if (userType === USER_TYPE.customer) {
    return <CustomerSignUpForm {...props} />
  }

  return <ShopSignUpForm {...props} />
}

export default StepAccountRegistration
